import React from "react";
import { StyleSheet } from "react-native";
import { useTheme } from "react-native-paper";
import { Text } from "../utils/fontsLoader";
import PropTypes from "prop-types";

FieldErrorText.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export default function FieldErrorText({ errorMessage }) {
  const theme = useTheme();
  const styles = StyleSheet.create({
    textError: {
      color: theme.colors.error
    }
  });

  return <Text style={styles.textError}>{errorMessage}</Text>;
}